module.exports = __webpack_public_path__ + "media/images/blau-simple-6857e7af9ebcc1ed31ee0d4fa8415ec6.svg";